import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from './auth/authConfig';
import { msalInternalConfig } from './auth/internalAuthConfig';

export const msalInstance = new PublicClientApplication(msalConfig);
export const msalInternalInstance = new PublicClientApplication(msalInternalConfig);
await msalInternalInstance.initialize();
await msalInstance.initialize().then(() => {
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  } 

  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS
      ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
      ||
      event.eventType === EventType.SSO_SILENT_SUCCESS
    ) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  const root = createRoot(document.getElementById('root'));
 
  root.render(
    <BrowserRouter>
      <App pca={msalInstance} internalAuth={msalInternalInstance} />
    </BrowserRouter>
  );
});